// slideshow-swiper.js
document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.slideshow-swiper');

  containers.forEach((container) => {
    // Se já tiver um Swiper instanciado, destrói
    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    // Lê os atributos data
    const autoplay = container.dataset.autoplay === 'true';
    const speed = parseInt(container.dataset.speed) * 1000 || 5000;
    const effect = container.dataset.effect || 'slide';
    const navigationType = container.dataset.navigationType || 'dots';
    const slideHeight = container.dataset.slideHeight;

    // Configuração base
    const swiperParams = {
      loop: true,
      effect: effect,
      speed: 800,
      autoplay: autoplay ? { delay: speed, disableOnInteraction: false } : false,
      // Navegação (setas)
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      // Paginação (dots)
      pagination: {
        el: container.querySelector('.swiper-pagination:not(.long-dots-pagination)'),
        clickable: true,
        dynamicBullets: true,
      },
      preventClicks: true,
      preventClicksPropagation: true,
      // Eventos
      on: {
        // Reinicia barra de progresso (se houver) e long dots
        slideChangeTransitionStart: function () {
          // Barra separada (se existir)
          const progressBar = container.querySelector('.progress-bar');
          if (progressBar) {
            progressBar.style.width = '0%';
          }
          // Long dots: reseta o fill do bullet ativo
          if (navigationType === 'long_dots') {
            const bullets = this.pagination?.bullets;
            if (bullets) {
              const activeIndex = this.realIndex;
              const activeBullet = bullets[activeIndex];
              if (activeBullet) {
                const fill = activeBullet.querySelector('.progress-fill');
                if (fill) {
                  fill.style.width = '0%';
                }
              }
            }
          }
        },
        // Atualização contínua do progresso
        autoplayTimeLeft: function (s, time, progress) {
          // progress é um valor de 0 a 1 (0 = início, 1 = fim do slide)
          const percent = (1 - progress) * 100; // de 0 a 100

          // Barra separada (se existir)
          const progressBar = container.querySelector('.progress-bar');
          if (progressBar) {
            progressBar.style.width = percent + '%';
          }

          // Long dots: atualiza o fill do bullet ativo
          if (navigationType === 'long_dots') {
            const bullets = s.pagination?.bullets;
            if (bullets) {
              const activeIndex = s.realIndex;
              const activeBullet = bullets[activeIndex];
              if (activeBullet) {
                const fill = activeBullet.querySelector('.progress-fill');
                if (fill) {
                  fill.style.width = percent + '%';
                }
              }
            }
          }
        },
      },
    };

    // --- Ajustes específicos para "long dots" ---
    if (navigationType === 'long_dots') {
      const pagEl = container.querySelector('.swiper-pagination.long-dots-pagination');
      if (pagEl) {
        swiperParams.pagination = {
          el: pagEl,
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="${className} long-dot" data-index="${index}"><span class="progress-fill"></span></span>`;
          },
        };
        // Remove a paginação padrão
        delete swiperParams.pagination.dynamicBullets;
      }
    }

    // --- Se não houver setas, remove a navegação ---
    if (!container.querySelector('.swiper-button-next')) {
      delete swiperParams.navigation;
    }

    // --- Se não houver paginação (exceto long_dots já tratado), remove ---
    if (!container.querySelector('.swiper-pagination:not(.long-dots-pagination)') && navigationType !== 'long_dots') {
      delete swiperParams.pagination;
    }

    // --- Altura adaptativa ---
    if (slideHeight === 'adapt_image') {
      const firstSlide = container.querySelector('.swiper-slide');
      const img = firstSlide?.querySelector('img');
      if (img && img.complete) {
        container.style.setProperty('--slide-aspect-ratio', img.naturalWidth / img.naturalHeight);
      } else if (img) {
        img.addEventListener('load', () => {
          container.style.setProperty('--slide-aspect-ratio', img.naturalWidth / img.naturalHeight);
        });
      }
    }

    // --- Inicializa o Swiper ---
    const swiper = new Swiper(container, swiperParams);
    container.swiper = swiper;
  });
});

// Re-inicializa quando a seção for carregada no editor do Shopify
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    const slider = section.querySelector('.slideshow-swiper');
    if (slider) {
      setTimeout(() => {
        if (slider.swiper) {
          slider.swiper.destroy(true, true);
        }
        // Dispara o evento para recarregar
        const evt = new Event('DOMContentLoaded');
        document.dispatchEvent(evt);
      }, 100);
    }
  });
}